import { render } from "./Activate.vue?vue&type=template&id=63ac1c08&scoped=true"
import script from "./Activate.vue?vue&type=script&lang=js"
export * from "./Activate.vue?vue&type=script&lang=js"

import "./Activate.vue?vue&type=style&index=0&id=63ac1c08&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ac1c08"]])

export default __exports__